let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b50pw")).then(() => parcelRequire('bMv8t'));